var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ButtonComponent',{class:{
      'elder-button--disabled': _vm.config.disabled,
      'elder-button--invalid': _vm.config.invalid,
    },attrs:{"label":_vm.data.name,"icon":_vm.data.icon,"theme":_vm.data.theme,"promise":_vm.promise,"loading-label":_vm.config.loadingLabel,"success-label":_vm.config.successLabel},on:{"click":_vm.onClick}}),(_vm.dialog)?_c('ActionModal',{attrs:{"value":_vm.data,"promise":_vm.promise},on:{"close":_vm.reset,"submit":_vm.submit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }